<!-- <div class="card">
  <div class="row m-left-0 m-right-0">
    <div class="col-menu-main">
      <div class="navigation-menu-item" [routerLink]="'company'" [attr.data-intercom-target]="'Admin Company'" [routerLinkActive]="'menu-item-selected'">
        <h4 class="standard-heading">Company</h4>
        <div class="standard-description">Customise and manage your company</div>
      </div>
      <div class="navigation-menu-item" [routerLink]="'goals'" [attr.data-intercom-target]="'Admin Goals'" [routerLinkActive]="'menu-item-selected'">
        <h4 class="standard-heading" translate>{{eGoalsMessages.GOALS}}</h4>
        <div class="standard-description">Manage privileges and templates</div>
      </div>
      <div class="navigation-menu-item" [routerLink]="'surveys'" [attr.data-intercom-target]="'Admin Surveys'" [routerLinkActive]="'menu-item-selected'">
        <h4 class="standard-heading" translate>{{eSurveysMessages.SURVEYS}}</h4>
        <div class="standard-description">Manage which people can create and view results</div>
      </div>
      <div class="navigation-menu-item" [routerLink]="'features'" [attr.data-intercom-target]="'Admin Features'" [routerLinkActive]="'menu-item-selected'">
        <h4 class="standard-heading">Features</h4>
        <div class="standard-description">Toggle frankli features off and on</div>
      </div>
      <div class="navigation-menu-item" [routerLink]="'feedback'" [attr.data-intercom-target]="'Admin Feedback'" [routerLinkActive]="'menu-item-selected'">
        <h4 class="standard-heading" translate>{{eFeedbackMessages.FEEDBACK}}</h4>
        <div class="standard-description" translate>{{eFeedbackMessages.MANAGE_FEEDBACK}}</div>
      </div>
      <div class="navigation-menu-item" [routerLink]="'evaluations'" [attr.data-intercom-target]="'Admin Evaluations'" [routerLinkActive]="'menu-item-selected'">
        <h4 class="standard-heading">Review Cycles</h4>
        <div class="standard-description">Create & manage</div>
      </div>
      <div class="navigation-menu-item" [routerLink]="'one-to-ones'" [attr.data-intercom-target]="'Admin One To Ones'" [routerLinkActive]="'menu-item-selected'">
        <h4 class="standard-heading" translate>{{eOneToOneMessages.ONE_TO_ONES}}</h4>
        <div class="standard-description" translate>{{eOneToOneMessages.MANAGE_ONE_TO_ONES}}</div>
      </div>
      <div class="navigation-menu-item" [routerLink]="'analytics'" [attr.data-intercom-target]="'Admin Analytics'" [routerLinkActive]="'menu-item-selected'">
        <h4 class="standard-heading">Analytics</h4>
        <div class="standard-description">View your peoples analytics</div>
      </div>
      <div class="navigation-menu-item" [routerLink]="'integrations'" [attr.data-intercom-target]="'Integrations'" [routerLinkActive]="'menu-item-selected'">
        <h4 class="standard-heading">Integrations</h4>
        <div class="standard-description">Connect Frankli with your favourite applications</div>
      </div>
    </div>
    <div class="col-router-outlet">
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div> -->

<router-outlet></router-outlet>
<ng-container *ngIf="route.children.length === 0">
  <div class="text-right p-bottom-15" *ngIf="setupComplete">
    <a [routerLink]="['/company-setup/steps']">Quick start</a>
  </div>
  <div class="row">
    <div class="col-md-3 col-sm-4" *ngIf="!setupComplete">
      <div class="card admin-card text-center" [routerLink]="['quick-start/steps']" [attr.data-intercom-target]="'Admin Quick Start'">
        <img class="admin-icon" src="assets/img/icons/frankli-admin-set-up-steps.svg" alt="Admin Quick Start"/>
        <div class="admin-card-title">Quick start</div>
        <div class="admin-card-description">Follow these steps to help you get started using Frankli</div>
        <app-setup-steps-remaining-display [stepTypes]="allSetupSteps"></app-setup-steps-remaining-display>
      </div>
    </div>

    <div class="col-md-3 col-sm-4">
      <div class="card admin-card text-center" [routerLink]="'company'" [attr.data-intercom-target]="'Admin Company'">
        <img class="admin-icon" src="assets/img/icons/frankli-admin-company.svg" alt="Admin Company"/>
        <div class="admin-card-title">Company</div>
        <div class="admin-card-description">Customise and manage your company</div>
        <app-setup-steps-remaining-display [stepTypes]="companySetupSteps"></app-setup-steps-remaining-display>
      </div>
    </div>

    <div class="col-md-3 col-sm-4" *ngIf="!globals.company.featureLocked">
      <div class="card admin-card text-center" [routerLink]="'features'" [attr.data-intercom-target]="'Admin Features'">
        <img class="admin-icon" src="assets/img/icons/frankli-admin-features.svg" alt="Admin Features"/>
        <div class="admin-card-title" translate>{{eAdminMessages.MANAGE_FEATURES.MANAGE_FEATURES}}</div>
        <div class="admin-card-description" translate>{{eAdminMessages.MANAGE_FEATURES.MANAGE_FEATURES_DESCRIPTION_SHORT}}</div>
        <app-setup-steps-remaining-display [stepTypes]="[eCompanySetUpStepType.SET_FEATURES]"></app-setup-steps-remaining-display>
      </div>
    </div>

    <div class="col-md-3 col-sm-4">
      <div class="card admin-card text-center" [routerLink]="'integrations'" [attr.data-intercom-target]="'Integrations'">
        <img class="admin-icon" src="assets/img/icons/frankli-admin-integrations.svg" alt="Integrations"/>
        <div class="admin-card-title">Integrations</div>
        <div class="admin-card-description">Connect Frankli with your favourite applications</div>
        <app-setup-steps-remaining-display [stepTypes]="[eCompanySetUpStepType.VIEW_INTEGRATIONS]"></app-setup-steps-remaining-display>
      </div>
    </div>

    <div class="col-md-3 col-sm-4" *ngIf="globals.hasFeature(eFeature.GOALS)">
      <div class="card admin-card text-center" [routerLink]="'goals'" [attr.data-intercom-target]="'Admin Goals'">
        <img class="admin-icon" src="assets/img/icons/frankli-admin-goals.svg" alt="Admin Goals"/>
        <div class="admin-card-title" translate>{{eGoalsMessages.GOALS}}</div>
        <div class="admin-card-description">Manage privileges and templates</div>
        <app-setup-steps-remaining-display [stepTypes]="[eCompanySetUpStepType.SET_GOAL_PERMISSIONS]"></app-setup-steps-remaining-display>
      </div>
    </div>

    <div class="col-md-3 col-sm-4" *ngIf="globals.hasFeature(eFeature.SURVEYS)">
      <div class="card admin-card text-center" [routerLink]="'surveys'" [attr.data-intercom-target]="'Admin Surveys'">
        <img class="admin-icon" src="assets/img/icons/frankli-admin-surveys.svg" alt="Admin Surveys"/>
        <div class="admin-card-title" translate>{{eSurveysMessages.SURVEYS}}</div>
        <div class="admin-card-description">Manage which people can create and view results</div>
      </div>
    </div>

    <div class="col-md-3 col-sm-4" *ngIf="globals.hasFeature(eFeature.FEEDBACK_UNPROMPTED)">
      <div class="card admin-card text-center" [routerLink]="'feedback'" [attr.data-intercom-target]="'Admin Feedback'">
        <img class="admin-icon" src="assets/img/icons/frankli-admin-feedback-icon.svg" alt="Admin Feedback"/>
        <div class="admin-card-title" translate>{{eFeedbackMessages.FEEDBACK}}</div>
        <div class="admin-card-description" translate>{{eFeedbackMessages.MANAGE_FEEDBACK}}</div>
        <app-setup-steps-remaining-display [stepTypes]="[eCompanySetUpStepType.CONFIGURE_UNPROMPTED_FEEDBACK]"></app-setup-steps-remaining-display>
      </div>
    </div>

    <div class="col-md-3 col-sm-4" *ngIf="globals.hasFeature(eFeature.EVALUATION_CYCLES)">
      <div class="card admin-card text-center" [routerLink]="'evaluations'" [attr.data-intercom-target]="'Admin Evaluations'">
        <img class="admin-icon" src="assets/img/icons/frankli-admin-employee-evaluations.svg" alt="Admin Evaluations"/>
        <div class="admin-card-title">Review Cycles</div>
        <div class="admin-card-description">Create & manage</div>
      </div>
    </div>

    <div class="col-md-3 col-sm-4" *ngIf="globals.hasFeature(eFeature.ONE_TO_ONE)">
      <div class="card admin-card text-center" [routerLink]="'one-to-ones'" [attr.data-intercom-target]="'Admin One To Ones'">
        <img class="admin-icon" src="assets/img/icons/frankli-admin-one-to-one.svg" alt="Admin One To Ones"/>
        <div class="admin-card-title" translate>{{eOneToOneMessages.ONE_TO_ONES}}</div>
        <div class="admin-card-description" translate>{{eOneToOneMessages.MANAGE_ONE_TO_ONES}}</div>
        <app-setup-steps-remaining-display [stepTypes]="[eCompanySetUpStepType.CREATE_DEFAULT_TALKING_POINTS]"></app-setup-steps-remaining-display>
      </div>
    </div>

    <div class="col-md-3 col-sm-4" *ngIf="globals.hasFeature(eFeature.CAREERS) && (globals.hasFeature(eFeature.CAREER_PATHWAYS) || globals.hasFeature(eFeature.QUESTION_TEMPLATES))">
      <div class="card admin-card text-center" [routerLink]="'careers'" [attr.data-intercom-target]="'Admin Careers'">
        <img class="admin-icon" src="assets/img/icons/frankli-admin-careers.svg" alt="Admin Careers"/>
        <div class="admin-card-title" translate>{{eCareerMessages.CAREERS}}</div>
        <div class="admin-card-description" translate>{{eCareerMessages.MANAGE_CAREERS}}</div>
      </div>
    </div>

    <div class="col-md-3 col-sm-4">
      <div *ngIf="globals.hasFeature(eFeature.ANALYTICS)" class="card admin-card text-center" [routerLink]="'analytics'" [attr.data-intercom-target]="'Admin Analytics'">
        <img class="admin-icon" src="assets/img/icons/frankli-admin-user-activity.svg" alt="Admin Analytics"/>
        <div class="admin-card-title">Analytics</div>
        <div class="admin-card-description">View your peoples analytics</div>
      </div>
    </div>

    <div class="col-md-3 col-sm-4">
      <div class="card admin-card text-center" (click)="openOffersPage()" [attr.data-intercom-target]="'Admin Offers'">
        <img class="admin-icon" src="assets/img/icons/frankli-admin-offers.svg" alt="Admin Offers"/>
        <div class="admin-card-title">Offers</div>
        <div class="admin-card-description">Check out the offers we provide</div>
      </div>
    </div>
  </div>
</ng-container>